// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React, { createRef } from 'react';
import ReactDOM from 'react-dom';
interface ColorPickerProps {
    defaultColor?: string;
    defaultOpacity?: number;
    handleApplyClick?: (r: number, g: number, b: number, a: number) => void;
    handlePropertyChnage?: (r: number, g: number, b: number, a: number) => void;
    opacity?: boolean;
}

declare var ej: any;
class ColorPicker extends React.Component<ColorPickerProps, any> {
    _colorPickerRef = createRef<HTMLInputElement>();
    private _id: string;

    constructor(props: ColorPickerProps) {
        super(props);
        this._id = `colorPicker-${Math.floor(Math.random() * 99999)}`;
    }

    private _setOptions = (props: ColorPickerProps) => {

        let container = $(this._colorPickerRef.current) as any;
        let options: any = {
            buttonMode: ej.ButtonMode.Dropdown,
            locale: InovxLoader.getSyncfusionLocale()
        }

        if (props.defaultColor) {
            options.value = props.defaultColor;
        }

        if (props.defaultOpacity) {
            options.opacityValue = props.defaultOpacity * 100;
        }

        if (props.handleApplyClick) {
            var that = this;
            options.select = function (e: any) {
                
                let { r, g, b, a } = (this).getColor();
                props.handleApplyClick(r, g, b, a);
            }
        }

        if (props.opacity === false) {
            options.enableOpacity = false;
        }

        container.ejColorPicker(options);
    }

    
    shouldComponentUpdate(nextProps: ColorPickerProps, nextState: any) {
        // Never update this component...
        return false;
    }

    UNSAFE_componentWillReceiveProps(nextProps: ColorPickerProps) {
        this._setOptions(nextProps);       

    }
    
    componentDidMount() {
        this._setOptions(this.props);
    }

    componentWillUnmount() {
        let container = $(this._colorPickerRef.current) as any;
        container.ejColorPicker("destroy");
    }

    render() {
        return <input type="text" id={this._id} ref={this._colorPickerRef} />
    }
}

export default ColorPicker;